import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import { i18n } from 'i18n';
import { QAQCAreaPageParams } from 'modules/QAQC/QAQCAreaPage/constants';
import makePage from 'modules/makePage';
import { DETAILS_ROUTE_PATH } from 'modules/project/ProjectAreaPage/constants';
import { Permission } from 'providers/authorisation';
import { partial } from 'ramda';
import withLicenceAndDisclaimer from '../withLicenceAndDisclaimer';
import * as constants from './constants';
import useQAQCTablePageQueries, { QAQCTablePageQueries } from './useQAQCTablePageQueries';

const QAQCTablePage = lazyWithSuspense(() => import('./QAQCTablePage'));

const page: Page<constants.QAQCTablePageParams> = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  authorise: (context, params) => ({
    handler: partial(context.functions.validatePermission, [Permission.ManagePours]),
    teamId: params.projectId,
  }),
  component: withLicenceAndDisclaimer({
    pageDataHook: useQAQCTablePageQueries,
    Component: makePage<QAQCAreaPageParams, [], QAQCTablePageQueries>({
      WrappedPage: QAQCTablePage,
      titleFn: () => i18n._(constants.TITLE),
      parentPathTemplate: DETAILS_ROUTE_PATH,
      parentTitleFn: () => i18n._('Dashboard'),
    }),
  }),
};

export default page;
